module.exports = __webpack_public_path__ + "static/media/warning.2b3a5b64.png";